import React, { useEffect, useState, useRef } from "react";
import styles from "./mobilewrite.module.css";
import { ReactComponent as ArrowLeftLight } from "../../../src/svg/arrow-left-light.svg";
import { ReactComponent as ChevronRight } from "../../../src/svg/chevron-right-light.svg";
import { ReactComponent as XmarkRegular } from "../../../src/svg/xmark-regular.svg";
import { ReactComponent as PlusRegular } from "../../../src/svg/plus-regular.svg";

import { useHistory } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { ReactComponent as ImageSvg } from "../../svg/image-outline.svg";
import { IonApp } from '@ionic/react';
import { CssVarsProvider } from '@mui/joy/styles';


import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import Radio from '@mui/joy/Radio';
import RadioGroup from '@mui/joy/RadioGroup';
import Person from '@mui/icons-material/Person';
import People from '@mui/icons-material/People';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import EmailIcon from '@mui/icons-material/Email';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

import { Camera, CameraResultType } from "@capacitor/camera";
import { NativeSettings, AndroidSettings, IOSSettings } from "capacitor-native-settings";
import { useIonAlert, IonLoading } from "@ionic/react";
import { Filesystem } from "@capacitor/filesystem";

import { Preferences } from "@capacitor/preferences";

import ImageViewer from "../etc/imageviewer/imageviewer";

import { IonModal, IonContent } from '@ionic/react';
import AspectRatio from "@mui/joy/AspectRatio";
import { opinionKinds } from "../../dashboard/components/controls/totalsearch";





const MobileOpinionWrite: React.FC<any> = (props) => {

    const [showLoading, setShowLoading] = useState(false);

    const [alignment, setAlignment] = useState("named");
    const [alignmentValueText, setAlignmentValueText] = useState("실명 제출");

    const history = useHistory();
    const [platform, setPlatform] = useState("");
    const [open, setOpen] = useState(false);
    const modal = useRef<any>(null);
    const modal2 = useRef<any>(null);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const [kindValue, setKindValue] = useState("");
    const [kindValueText, setKindValueText] = useState("");
    const [description, setDescription] = useState("");

    const [presentAlert] = useIonAlert();

    const [imageWebpathArray, setImageWebPathArray] = useState<any>([]);
    const [imageNativePathArray, setImageNativePathArray] = useState<any>([]);
    const [images, setImages] = useState<any>([]);

    const [cardHeight, setCardHeight] = useState(0);
    const cardRef = useRef<any>(null);

    const [addDivHeight, setAddDivHeight] = useState(0);
    const addDivRef = useRef<any>(null);

    const [ionModalOpen, setIonModalOpen] = useState(false);
    const [ionModalSrc, setIonModalSrc] = useState("");


    const getHeight = (ratioRef: any, ratio: any) => {
        const width = ratioRef.current.offsetWidth;
        const height = width * ratio;
        return height;

    }

    useEffect(() => {

        


        const handleBackButton = () => {

            if(isModalOpen){
                setIsModalOpen(false);
                return;
            }


            
            history.goBack();
        }

        //backbutton 눌리면 handleBackButton 실행
        document.addEventListener("backbutton", handleBackButton);

        return () => {
            document.removeEventListener("backbutton", handleBackButton);
        }

    }, [isModalOpen]);

    //추가 박스 넓이 높이 비율 맞추기
    useEffect(() => {

        const ratio = 0.14;

        if (addDivRef && addDivRef.current) {
            setAddDivHeight(getHeight(addDivRef, ratio));
        }

        window.addEventListener("resize", () => {
            if (addDivRef && addDivRef.current) {
                setAddDivHeight(getHeight(addDivRef, ratio));
            }
        })

        return window.removeEventListener("resize", () => {
            if (addDivRef && addDivRef.current) {
                setAddDivHeight(getHeight(addDivRef, ratio));
            }
        })

    }, [addDivRef]);


    //카도 넓이 높이 비율 맞추기
    useEffect(() => {

        const ratio = 0.19;

        if (cardRef && cardRef.current) {
            setCardHeight(getHeight(cardRef, ratio));
        }

        window.addEventListener("resize", () => {
            if (cardRef && cardRef.current) {
                setCardHeight(getHeight(cardRef, ratio));
            }
        })

        return window.removeEventListener("resize", () => {
            if (cardRef && cardRef.current) {
                setCardHeight(getHeight(cardRef, ratio));
            }
        })

    }, [cardRef]);

    //플랫폼 정보 확인
    useEffect(() => {
        const platform = Capacitor.getPlatform();

        if (platform) {
            setPlatform(platform);
        }

        
        

    }, []);

    //라디오 변경 처리
    const handleChange = (e: any) => {
        setKindValue(e.target.value);

        var text = "";

        opinionKinds.forEach((eachKind: any) => {

            if(eachKind.value === e.target.value){
                text = eachKind.lable;
            }

        });

        setKindValueText(text);

        // switch (e.target.value) {
        //     case "live":
        //         setKindValueText("생활");
        //         break;
        //     case "change":
        //         setKindValueText("자리변경");
        //         break;
        //     case "consult":
        //         setKindValueText("담임상담");
        //         break;
        //     case "question":
        //         setKindValueText("질의응답");
        //         break;
        //     case "coaching":
        //         setKindValueText("과외");
        //         break;
        //     case "ceo":
        //         setKindValueText("대표에게만");
        //         break;
        //     case "etc":
        //         setKindValueText("기타");
        //         break;
        // }

    }

    const handleChange2 = (e: any) => {
        setAlignment(e.target.value);

        switch (e.target.value) {
            case "named":
                setAlignmentValueText("실명 제출");
                break;
            case "nonamed":
                setAlignmentValueText("익명 제출");
                break;
        }

    }

    const handleImageClick = () => {
        if (images.length > 0) {
            setIsModalOpen(true);
        } else {
            getImage();
        }
    }



    const getImage = async () => {

        const permissionStatus = await Camera.checkPermissions();

        

        if (permissionStatus.camera === "denied" || permissionStatus.photos === "denied") {
            

            presentAlert({
                header: "접근 권한이 필요합니다",
                subHeader: "카메라, 사진첩 접근 권한이 필요합니다.",
                buttons: [
                    {
                        text: "Cancel",
                        role: "cancel",
                    },
                    {
                        text: "OK",
                        role: "confirm",
                        handler: () => {
                            NativeSettings.open({
                                optionAndroid: AndroidSettings.ApplicationDetails,
                                optionIOS: IOSSettings.App
                            })
                        }
                    }
                ]
            })

            return;
        }


        var image;

        try {
            image = await Camera.getPhoto({
                quality: 90,
                allowEditing: false,
                resultType: CameraResultType.Uri,
            })
        } catch (e) {
            
            return;
        }

        if (!image) {
            return;
        }
        setShowLoading(true);



        if (image.webPath) {
            const newImageWebPathArray: any = imageWebpathArray;
            newImageWebPathArray.push(image.webPath);
            setImageWebPathArray(newImageWebPathArray);
        }

        if (Capacitor.isNativePlatform()) {

            if (!image.path) {
                
                return;
            }

            const newImageNativePathArray = imageNativePathArray;
            newImageNativePathArray.push(image.path);
            setImageNativePathArray([...newImageNativePathArray]);

            const base64data : any = await Filesystem.readFile({
                path: image.path
            });

            const byteData = atob(base64data.data);

            const byteNumbers = new Array(byteData.length);

            for (var i = 0; i < byteData.length; i++) {
                byteNumbers[i] = byteData.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);

            

            const blob = new Blob([byteArray], { type: "image/jpeg" });

            
            
            

            const file = new File([blob], "opinionImage.jpeg", { type: blob.type });
            

            const newImages: any = images;
            newImages.push(file);
            setImages([...newImages]);
        } else {

            if (!image.webPath) {
                return;
            }

            const byteArray = await fetch(image.webPath);
            const blob = await byteArray.blob();
            

            const file = new File([blob], "opinionImage.jpeg", { type: blob.type });
            

            const newImages: any = images;
            newImages.push(file);
            setImages([...newImages]);
        }

        setShowLoading(false);
    }

    const removeImage = (index: number) => {
        const newImages = images.filter((eachImage: any, imageIndex: any) =>
            index !== imageIndex
        );

        const newImageWebPathArray = imageWebpathArray.filter((eachImagePath: any, imagePathIndex: any) =>
            index !== imagePathIndex
        );

        const newImageNativePathArray = imageNativePathArray.filter((eachImagePath : any, imagePathIndex : number) => 
            index !== imagePathIndex
        );

        setImages([...newImages]);
        setImageWebPathArray([...newImageWebPathArray]);
        setImageNativePathArray([...newImageNativePathArray]);

    }

    const submit = async (e: any) => {

        if (!kindValue || !description) {
            alert("내용을 먼저 적어주세요");
            return;
        }

        setShowLoading(true);

        const formData = new FormData;
        var message = { kindValue: kindValue, description: description, named: alignment };
        formData.append("message", JSON.stringify(message));

        images.forEach((eachImage: any) => {
            formData.append("opinion_picture", eachImage);
        });

        var token: any = "";

        if (window.electron) {
            token = window.electron.sendMessageApi.getToken();
        }

        if (Capacitor.isNativePlatform()) {
            const { value } = await Preferences.get({ key: "token" });
            token = value;
        }


        fetch("https://peetsunbae.com/dashboard/search/opinion", {
            method: "POST",
            headers: { "Authorization": token },
            credentials: "include",
            body: formData
        }).then((response) => {
            response.json()
                .then((result) => {
                    if (result.message === "success") {
                        setShowLoading(false);
                        alert("성공");
                        history.push("/mobiledashboard/opinion");
                    }
                    if (result.message === "fail") {
                        setShowLoading(false);
                        alert(result.failMessage);
                    }
                })
        }).catch((error) => {
            
        })




    }

    const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    function niceBytes(x: any) {

        let l = 0, n = parseInt(x, 10) || 0;

        while (n >= 1024 && ++l) {
            n = n / 1024;
        }

        return (n.toFixed(n < 10 && l > 0 ? 1 : 0) + '' + units[l]);
    }


    const ionModalClose = () => {
        setIonModalOpen(false);
    }

    const pictureClick = (index : number) => {
        setIonModalSrc(imageWebpathArray[index]);
        setIonModalOpen(true);
    }


    return (
        <IonApp>
            <div style={{ 
                    // paddingTop: "env(safe-area-inset-top)" 
                    paddingTop : "var(--safe-area-inset-top)"
            }}>
                <div className={styles.headerDiv}>
                    <div className={`${styles.header} ${platform === "ios" ? styles.ios : ""}`}>
                        <div className={styles.backBtnDiv}
                            onClick={() => { history.goBack(); }}
                        >
                            <ArrowLeftLight
                                className={styles.arrowLeft}
                            />
                        </div>

                        <div className={styles.titleText}>
                            의견 보내기
                        </div>

                        <div className={styles.btns}>
                            <div className={styles.imageIconDiv} onClick={handleImageClick}>
                                <ImageSvg className={styles.imageIcon} />
                                <div className={`${styles.badge} ${images.length ? styles.active : ""}`}>
                                    {images.length ? images.length : ""}
                                </div>
                            </div>
                            <div className={`${styles.submit} ${(kindValue && description) ? styles.active : ""}`} onClick={(kindValue && description) ? submit : () => { }}>
                                확인
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.bodyDiv}>
                    <div className={`${styles.body}`}>

                        <div className={`${styles.kindSelect}`} id="open-modal2">
                            <div className={`${styles.kindSelectText} ${alignmentValueText ? styles.active : ""}`}>
                                {alignmentValueText ? alignmentValueText : "실명/익명"}
                            </div>
                            <div className={styles.kindSelectChevron}>
                                <ChevronRight fill="rgba(0,0,0,0.4)" className={styles.chevronRight} />
                            </div>
                        </div>

                        <div className={`${styles.kindSelect}`} id="open-modal">

                            <div className={`${styles.kindSelectText} ${kindValueText ? styles.active : ""}`}>
                                {kindValueText ? kindValueText : "의견 종류"}
                            </div>
                            <div className={styles.kindSelectChevron}>
                                <ChevronRight fill="rgba(0,0,0,0.4)" className={styles.chevronRight} />
                            </div>
                        </div>

                        <div className={styles.descriptionDiv}>
                            <textarea value={description} onChange={(e: any) => { setDescription(e.target.value); }} rows={18} className={styles.textarea} placeholder="내용을 작성해주세요" />
                        </div>
                    </div>
                </div>






                <IonModal
                    ref={modal}
                    trigger="open-modal"
                    initialBreakpoint={0.8}
                    breakpoints={[0, 0.8]}
                    handleBehavior="cycle"
                >
                    <IonContent className="ion-padding">
                        <CssVarsProvider>
                            <RadioGroup aria-label="Your plan" name="people" defaultValue="Individual" value={kindValue} onChange={handleChange}>
                                <List
                                    sx={{
                                        marginTop: "2rem",
                                        minWidth: 240,
                                        '--List-gap': '0.5rem',
                                        '--List-item-paddingY': '1rem',
                                        '--List-item-radius': '8px',
                                        '--List-decorator-size': '32px',
                                    }}
                                >
                                    {
                                    // [{ lable: "생활", value: "live" }, { lable: "자리변경", value: "change" }, { lable: "질의응답", value: "question" }, { lable: "대표에게", value: "ceo" }, { lable: "기타", value: "etc" }]
                                    props.user &&
                                    opinionKinds.filter((eachKind : any) => {
                                        if(!eachKind.exceptAcademy && !eachKind.academies){
                                            return true;
                                        }

                                        if(eachKind.exceptAcademy){
                                            if(eachKind.exceptAcademy.includes(props.user.academy)){
                                                return false;
                                            }else{
                                                return true;
                                            }
                                        }

                                        if(eachKind.academies){
                                            if(eachKind.academies.includes(props.user.academy)){
                                                return true;
                                            }
                                        }

                                        return false;

                                    })
                                    .map((item, index) => (
                                        <ListItem variant="outlined" key={item.value}>
                                            <ListItemDecorator>
                                                {[<Person />, <People />, <QuestionAnswerIcon />, <QuestionMarkIcon />, <EmailIcon />, <MoreHorizIcon />][index]}
                                            </ListItemDecorator>
                                            <Radio
                                                overlay
                                                value={item.value}
                                                label={<span className={styles.radioItem}>{item.lable}</span>}
                                                sx={{ flexGrow: 1, flexDirection: 'row-reverse', paddingTop : "10px", paddingBottom : "10px" }}
                                                slotProps={{
                                                    action: ({ checked }) => ({
                                                        sx: (theme) => ({
                                                            ...(checked && {
                                                                inset: -1,
                                                                border: '2px solid',
                                                                borderColor: theme.vars.palette.primary[500],
                                                                borderRadius : 0
                                                            }),
                                                        }),
                                                    }),
                                                }}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </RadioGroup>
                        </CssVarsProvider>

                    </IonContent>
                </IonModal>



                <IonModal
                    ref={modal2}
                    trigger="open-modal2"
                    initialBreakpoint={0.3}
                    breakpoints={[0, 0.3]}
                    handleBehavior="cycle"
                >
                    <IonContent className="ion-padding">
                        <CssVarsProvider>
                            <RadioGroup aria-label="Your plan" name="people" defaultValue="Individual" value={alignment} onChange={handleChange2}>
                                <List
                                    sx={{
                                        marginTop: "2rem",
                                        minWidth: 240,
                                        '--List-gap': '0.5rem',
                                        '--List-item-paddingY': '1rem',
                                        '--List-item-radius': '8px',
                                        '--List-decorator-size': '32px',
                                    }}
                                >
                                    {[{ lable: "실명 제출", value: "named" }, { lable: "익명 제출", value: "nonamed" }].map((item, index) => (
                                        <ListItem variant="outlined" key={item.value}>
                                            <ListItemDecorator>
                                                {[<Person />, <QuestionMarkIcon />][index]}
                                            </ListItemDecorator>
                                            <Radio
                                                overlay
                                                value={item.value}
                                                label={<span className={styles.radioItem}>{item.lable}</span>}
                                                sx={{ flexGrow: 1, flexDirection: 'row-reverse', paddingTop : "10px", paddingBottom : "10px" }}
                                                slotProps={{
                                                    action: ({ checked }) => ({
                                                        sx: (theme) => ({
                                                            ...(checked && {
                                                                inset: -1,
                                                                border: '2px solid',
                                                                borderColor: theme.vars.palette.primary[500],
                                                                borderRadius : 0
                                                            }),
                                                        }),
                                                    }),
                                                }}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </RadioGroup>
                        </CssVarsProvider>

                    </IonContent>
                </IonModal>

                <IonModal isOpen={isModalOpen}>
                    <div style={{ 
                        // paddingTop: "env(safe-area-inset-top)" 
                        paddingTop: "var(--safe-area-inset-top)"
                    }}>
                        <div className={styles.headerDiv}>
                            <div className={`${styles.header} ${platform === "ios" ? styles.ios : ""}`}>
                                <div className={styles.backBtnDiv}
                                    onClick={() => { setIsModalOpen(false); }}
                                >
                                    <ArrowLeftLight
                                        className={styles.arrowLeft}
                                    />
                                </div>

                                <div className={styles.titleText}>
                                    첨부파일&nbsp;<span className={styles.imageNumber}>{images.length}</span>
                                </div>

                                <div className={styles.btns}>

                                </div>
                            </div>
                        </div>

                        <div className={styles.bodyDiv}>
                            <div className={styles.body}>
                                {
                                    images.map((eachImage: any, index: number) => {
                                        
                                        const imageSize = niceBytes(eachImage.size);
                                        return (
                                            <div className={styles.cardWrapper}>
                                                <CssVarsProvider>
                                                    <AspectRatio ratio="100/19" variant="plain">
                                                        <div key={index} className={`${styles.eachCard} ${images.length - 1 === index ? styles.last : ""}`} ref={cardRef}>
                                                            <div className={styles.eachImageDiv}>
                                                                <img src={imageWebpathArray[index]} className={styles.eachImage} onClick={(e: any) => { pictureClick(index); }} />
                                                            </div>
                                                            <div className={styles.eachImageText}>
                                                                <div className={styles.eachImageName}>
                                                                    첨부파일_{index + 1}.{eachImage.name.split(".")[eachImage.name.split.length - 1]}
                                                                </div>
                                                                <div className={styles.eachImageSize}>
                                                                    {imageSize}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </AspectRatio>
                                                </CssVarsProvider>
                                                <div className={styles.cancel} onClick={() => { removeImage(index); }}>
                                                    <XmarkRegular className={styles.xmark} fill="white" />
                                                </div>
                                            </div>
                                        )
                                    })
                                }

                                <div style={{height : "0.8rem"}}>
                                    
                                </div>
                                <CssVarsProvider>
                                    <AspectRatio ratio="100/14" variant="plain">
                                        <div onClick={getImage} className={styles.addDiv} ref={addDivRef} >
                                            <div className={styles.addDivTextDiv}>
                                                <div className={styles.plusDiv}>
                                                    <PlusRegular fill="white" className={styles.plus} />
                                                </div>
                                                <div className={styles.addText}>
                                                    사진 추가하기
                                                </div>
                                            </div>
                                        </div>
                                    </AspectRatio>
                                </CssVarsProvider>

                            </div>
                        </div>
                        <IonLoading
                            cssClass='my-custom-class'
                            isOpen={showLoading}
                            onDidDismiss={() => setShowLoading(false)}
                            message={'잠시만 기다려주세요'}
                        />

                        <ImageViewer
                            isModalOpen={ionModalOpen}
                            handleClose={ionModalClose}
                            title=""
                            src={ionModalSrc}
                        />
                    </div>
                </IonModal>



            </div>

            <IonLoading
                cssClass='my-custom-class'
                isOpen={showLoading}
                onDidDismiss={() => setShowLoading(false)}
                message={'잠시만 기다려주세요'}
            />
        </IonApp >

    );
}

export default MobileOpinionWrite;